(function(){
    var els = document.querySelectorAll('.sk-reveal');
    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){el.classList.add('is-in');});
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    },{threshold:.15});
    els.forEach(function(el){io.observe(el);});
  })();